import { useAppSelector } from 'app/store'

export default function useReadOnlyHook(): boolean {
  const {
    kcInfo: { isReadOnly },
  } = useAppSelector((state) => state.userData)

  return isReadOnly
}
